export const baseUrl = "https://fc-mp-af2ae419-8d72-4586-b078-94a30e971439.next.bspapp.com"

export const mapKey = "GGMBZ-JGFKB-ADTUQ-N4HEA-WHHL2-SUFUF"